module.exports = __webpack_public_path__ + "media/images/front/hospitals/yokohama_cu-7df373fa873935d26fa0628bb12845fb.jpg";